import { ViewEditModeContextProvider } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { Experience } from '../Common/Experience';

export const ModernExperienceDetails = () => {
  return (
    <ViewEditModeContextProvider>
      <Experience />
    </ViewEditModeContextProvider>
  );
};
